module.exports = __webpack_public_path__ + "img/review-3.e26bd581.png";